import { parseNumericConfigInput } from '../../../utils/parseNumericConfigInput.ts';

export type CommitOnBlurNumberOptions = {
  min?: number;
  max?: number;
};

export type NumberDraftState = {
  committed: number;
  draft: string;
  editing: boolean;
};

export function formatCommittedNumber(value: number): string {
  return String(value);
}

function clampNumber(
  value: number,
  options: CommitOnBlurNumberOptions = {},
): number {
  let next = value;
  if (options.min !== undefined) {
    next = Math.max(options.min, next);
  }
  if (options.max !== undefined) {
    next = Math.min(options.max, next);
  }
  return next;
}

export function parseNumberDraft(
  draft: string,
  options: CommitOnBlurNumberOptions = {},
): number {
  return clampNumber(parseNumericConfigInput(draft, 0), options);
}

export function numberDraftFromCommitted(committed: number): NumberDraftState {
  return {
    committed,
    draft: formatCommittedNumber(committed),
    editing: false,
  };
}

export function typeNumberDraft(
  state: NumberDraftState,
  draft: string,
): NumberDraftState {
  return {
    ...state,
    draft,
    editing: true,
  };
}

export function commitNumberDraft(
  state: NumberDraftState,
  options: CommitOnBlurNumberOptions = {},
): { state: NumberDraftState; didCommit: boolean } {
  const parsed = parseNumberDraft(state.draft, options);
  return {
    state: numberDraftFromCommitted(parsed),
    didCommit: parsed !== state.committed,
  };
}

export function revertNumberDraft(state: NumberDraftState): NumberDraftState {
  return numberDraftFromCommitted(state.committed);
}

/**
 * Keep the in-progress draft when a server value arrives mid-edit. The last
 * committed value still updates so blur/Escape use the latest valid number.
 */
export function applyIncomingCommitted(
  state: NumberDraftState,
  incoming: number,
): NumberDraftState {
  if (state.editing) {
    return {
      ...state,
      committed: incoming,
    };
  }
  return numberDraftFromCommitted(incoming);
}
